/** Renders an influence weight with at most two decimals in the user's locale. */
export function formatWeight(weight: number | null | undefined, locale: string): string {
  if (weight === null || weight === undefined || !Number.isFinite(weight)) return '';
  return new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(weight);
}
